// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_du-0";